(function ($) {

    //SINGLE prodotto

    $(document).on('click', '.accordion', function () {

        var elementId = $(this).attr('data-id');

        var accordionBody = '.accordion-body-' + elementId;

        // console.log(accordionBody);

        if ($(accordionBody).hasClass('show')) {
            $(accordionBody).removeClass('show');
            $(this).find('.arrow').removeClass('open');
        } else {
            $(accordionBody).addClass('show');
            $(this).find('.arrow').addClass('open');
        }
    });

    $(document).on('click', '.filter-toggler', function () {

        $('.childs-tax-wrapper').addClass('open');

    });

    $(document).on('click', '.exit-wrapper', function () {

        $('.childs-tax-wrapper').removeClass('open');

    });

    $(document).on('click', '#hover-exit', function () {

        $('.childs-tax-wrapper').removeClass('open');

    });

    if($('.filter-tax-wrapper').length){
        var eTop = $('.filter-tax-wrapper').offset().top; //get the offset top of the element

        $(window).scroll(function () { //when window is scrolled
            var distance = (eTop - $(window).scrollTop());
            if (distance < 110){
                $('.filter-tax-wrapper').addClass('resize');
            } else {
                $('.filter-tax-wrapper').removeClass('resize');
            }
        });
    }

    

})
(jQuery);
